import { Fragment, type CSSProperties } from 'react';
import styles from './BlurText.module.css';

type BlurTextElement = 'h1' | 'h2' | 'p';

interface BlurTextProps {
    text: string;
    as?: BlurTextElement;
    className?: string;
    id?: string;
    startDelayMs?: number;
    stepMs?: number;
}

export default function BlurText({ text, as: Element = 'p', className, id, startDelayMs = 0, stepMs = 90 }: BlurTextProps) {
    const words = text.split(' ');

    return (
        <Element id={id} className={[styles.text, className].filter(Boolean).join(' ')} aria-label={text}>
            {words.map((word, index) => (
                <Fragment key={`${word}-${index}`}>
                    <span
                        className={styles.word}
                        aria-hidden="true"
                        style={{ '--word-delay': `${startDelayMs + index * stepMs}ms` } as CSSProperties}
                    >
                        {word}
                    </span>
                    {index < words.length - 1 && ' '}
                </Fragment>
            ))}
        </Element>
    );
}
